

















































import {Vue, Component, Prop } from 'vue-property-decorator';
import * as api from '@/store/api'
import DetailContact from './DetailContact/DetailContact.vue'
import CategoryGroupPhonebook from './CategoryPhonebook/CategoryGroupPhonebook.vue'
import * as letterOwnerService from '@/store/Services/letterOwnerService';
import * as companyBranchServices from '@/store/Services/companyBranchServices';
import {PhoneBook} from '@/store/models/LetterOwner/PhoneBook';
import { CompanyBranch } from '@/store/models/CompanyBranch/CompanyBranch';



@Component({
     components:{DetailContact,CategoryGroupPhonebook}
})
export default class Phonebook extends Vue {
    shalltest= false;
    isLoading= false;
    shallshowDetailForm= false;
    serverTime = ''; 
    searchText= '';
    selectedPersonnelContactInfoId= '';
    selectedCompanyPersonnelContactInfoId= '';
    AllPhoneBook: PhoneBook[]=[];
    AllBranch: CompanyBranch[]=[];

    async created(){
        await this.GetAllCompanyBranch();
        await this.getAllPhoneBooks();
    }
    
    get filteredCompanies(){
        return [...new Set(this.filteredPhonebook.map(item => item.companyId))];
        // return this.filteredPhonebook.map(item => item.companyId);
    }
    get filteredPhonebook(){
        // if(!this.AllPhoneBook) return [];
        const noDuplicationData=this.AllPhoneBook?.filter((thing, i, arr) => arr.findIndex(t => t.id === thing.id) === i);
        return noDuplicationData.filter(item=> item.firstName?.includes(this.searchText) || item.companyName?.includes(this.searchText) 
        || item.lastName?.includes(this.searchText) || item.post?.includes(this.searchText) ).sort((obj1, obj2) => {
    if (obj1.companyName > obj2.companyName) {
        return 1;
    }
    if (obj1.companyName < obj2.companyName) {
        return -1;
    }
    return 0;
});
    }
    async GetAllCompanyBranch(){
        this.shalltest=true;
        try {
            this.isLoading=true;
            this.AllBranch=[];
            const allCompanyBranch=await companyBranchServices.GetAllCompanyBranch();
            this.AllBranch.push(...allCompanyBranch)
        } catch (error) {
            console.log(error);
        }finally{
            this.isLoading=false;
        }


    }
    async getAllPhoneBooks(){
        this.shalltest=true;
        try {
            this.isLoading=true;
            this.AllPhoneBook=[];
            const serverResult = await letterOwnerService.getAllPhoneBooks();
            this.AllPhoneBook.push(...serverResult);

        } catch (error) {
            console.log(error);
        }finally{
            this.isLoading=false;
        }


    }

    closePhonebookViewer(){
        this.shalltest=false;
        this.$router.replace({name: "ReceivedLetters"});
    }
    
     
}

